import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  InfoCircleFilled,
  PauseCircleFilled,
  WarningFilled,
} from '@ant-design/icons';
import { Tag } from 'antd';
import { useMemo } from 'react';

export interface IStateTagProps {
  state: string;
  color?: string;
  icon?: string;
}
export enum StateIcon {
  OK = 'ok',
  WARN = 'warn',
  ERROR = 'error',
  INFO = 'info',
  STOP = 'stop',
  PAUSE = 'pause',
}
const isHexColor = (color: string) => /^#([0-9A-F]{3}){1,2}$/i.test(color);

/**
 * Restituisce il componente icona React corrispondente a un valore di StateIcon.
 */
export function getStateIconComponent(icon?: string | null): React.ReactNode {
  switch (icon?.toLowerCase()) {
    case StateIcon.OK:
      return <CheckCircleFilled />;
    case StateIcon.WARN:
      return <WarningFilled />;
    case StateIcon.ERROR:
      return <CloseCircleFilled />;
    case StateIcon.STOP:
      return <ExclamationCircleFilled />;
    case StateIcon.PAUSE:
      return <PauseCircleFilled />;
    case StateIcon.INFO:
    default:
      return <InfoCircleFilled />;
  }
}

/**
 * Mappa un valore di StateIcon allo status di Ant Design Result.
 */
export function getStateResultStatus(
  icon?: string | null,
): 'success' | 'error' | 'warning' | 'info' {
  switch (icon?.toLowerCase()) {
    case StateIcon.OK:
      return 'success';
    case StateIcon.ERROR:
    case StateIcon.STOP:
      return 'error';
    case StateIcon.WARN:
    case StateIcon.PAUSE:
      return 'warning';
    default:
      return 'info';
  }
}

export function StateTag(props: IStateTagProps) {
  const { state, color, icon = StateIcon.INFO } = props;

  const renderIcon = useMemo(
    () => (icon ? getStateIconComponent(icon) : null),
    [icon],
  );

  const tagColor = color && isHexColor(color) ? color : 'default';

  return (
    <Tag color={tagColor} icon={renderIcon}>
      {state}
    </Tag>
  );
}
